<section class="section-white">
  <div class="section-container-inside">
    <h2 class="section-heading" *ngIf="stories?.header">
      <span>{{ stories?.header }}</span>
    </h2>
    <div class="responsive-padding-inline-96">
      <div class="center-container w-100">
        <div>
          <div class="flex-col gap-48">
            <div class="multi-row-grid">
              <div class="blog-container" *ngFor="let card of stories?.cards">
                <ng-container
                  *ngTemplateOutlet="figureTemplate; context: { item: card }"
                ></ng-container>
              </div>
            </div>
            <div class="single-row-scroll">
              <div *ngFor="let card of stories?.cards">
                <ng-container
                  *ngTemplateOutlet="figureTemplate; context: { item: card }"
                ></ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #figureTemplate let-card="item">
      <div class="blog-container-mobile">
        <div class="blog-image">
          <img
            class="responsive-radius-xl"
            src="{{
              card?.fields?.customerStoryHeroPanel?.fields?.image?.[0]?.fields
                ?.file?.url
            }}"
            alt="{{
              card?.fields?.customerStoryHeroPanel?.fields?.image?.[0]?.fields
                ?.title
            }}"
          />
        </div>
        <div class="latest-news-content">
          <h5 class="latest-news-heading">
            {{ card?.fields?.customerStoryHeroPanel?.fields?.title }}
          </h5>
        </div>
        <a
          class="stretched-link"
          href="{{ 'about-us/media-and-events/customer-stories/' + card?.fields?.webPageId | urlParams:queryParams }}"
        ></a>
        </div>
    </ng-template>
  </div>
</section>
